import { getLockedTreatmentMonths } from '@/services/main/consent';
import type { ConsentFormData } from '@/schemas/consentSchema';

const LOCKED_TREATMENT_MONTHS_CONFIRM_MESSAGE =
  '印刷済みまたは確定済みの月が存在します。よろしいですか？';

export type LockedTreatmentMonthsCheckContext = {
  serviceType: 'r2' | 'a2';
  siteType: string;
  clinicNumber: string;
  patientId: string;
  confirmFn: (message: string) => Promise<boolean>;
};

function buildLockedTreatmentMonthsConfirmMessage(months: string[]): string {
  return `${LOCKED_TREATMENT_MONTHS_CONFIRM_MESSAGE}(${months.join('、')})`;
}

export async function runLockedTreatmentMonthsCheck(
  data: ConsentFormData,
  ctx: LockedTreatmentMonthsCheckContext
): Promise<boolean> {
  const from = data.treatment_term_from;
  const to = data.treatment_term_to;
  if (!from || !to) return true;

  try {
    const response = await getLockedTreatmentMonths(
      ctx.siteType,
      ctx.clinicNumber,
      ctx.patientId,
      ctx.serviceType.toUpperCase(),
      from,
      to
    );
    const months = response.data.months ?? [];
    if (months.length === 0) return true;

    return ctx.confirmFn(buildLockedTreatmentMonthsConfirmMessage(months));
  } catch {
    return true;
  }
}
